import { IconProps } from './type';

export const ICUsers: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 128 128"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="42" cy="48" r="16" fill="#FF9E7A" opacity="0.7" />
            <path
                d="M18 94C20 78 30 68 42 68C54 68 64 78 66 94H18Z"
                fill="#FF9E7A"
                opacity="0.7"
            />
            <circle cx="86" cy="48" r="16" fill="#a797ff" opacity="0.7" />
            <path
                d="M62 94C64 78 74 68 86 68C98 68 108 78 110 94H62Z"
                fill="#a797ff"
                opacity="0.7"
            />
            <circle cx="64" cy="44" r="20" fill="#4f4b5c" />
            <path
                d="M30 104C33 82 47 70 64 70C81 70 95 82 98 104H30Z"
                fill="#4f4b5c"
            />
        </svg>
    );
};
